'use client';

import { useState } from 'react';
import styles from './FaqSectionWithoutCatergory.module.scss'
import cn from "clsx";
import ArrowSVG from '@/SvgIcons/ArrowDown';

const FaqWithCategoryProgram = ({ QuestionAnswer,isHome=false, isJobRole = false}) => {
  const sourceData = QuestionAnswer || [];
  const [expandedQuestion, setExpandedQuestion] = useState<number | null>(
    sourceData?.length > 0 ? 0 : null
  );

  const toggleQuestion = (index: number) => {
    setExpandedQuestion((prev) => (prev === index ? null : index));
  };
  return (
    <section>
      <div className={cn("lg:col-span-8", styles.faqblock)}>
        <h2 id = "faq-heading"
          className={cn("mb-8", styles.mainHeadingFaq , isHome && styles.homeHeadingFaq, isJobRole && styles.jobRoleHeading )}
        >
          Frequently Asked Questions
        </h2>
        {/* Questions */}
        {sourceData?.length > 0 ? (
          <div className="md:px-0 sm:!pl-2 px-4 space-y-4">
            {sourceData.map((faq, index) => (
              <div
                key={index}
                className={`${
                  expandedQuestion === index ? "text-gray-800" : "text-gray-700"
                }`}
              >
                <div
                  className="flex justify-between items-center cursor-pointer py-1"
                  onClick={() => toggleQuestion(index)}
                >
                 {faq.Question? <span className={cn("font-medium", styles.faqQue, {
                    [styles.activeQuestion] : expandedQuestion === index,
                    [styles.jobRoleQue]: isJobRole,
                  })}>
                    {faq.Question}
                  </span>:<span className={cn("font-medium", styles.faqQue, {
                    [styles.activeQuestion] : expandedQuestion === index
                  })} dangerouslySetInnerHTML={{__html : faq.QuestionCK}}></span>}
                  <span className={styles.icon}>
                    <ArrowSVG
                    id = {`faq-icon-${index}`}
                      rotate={expandedQuestion === index ? 180 : 0}
                      width={16}
                      height={16}
                      isActive={expandedQuestion === index} 
                      color="blue"
                    />
                  </span>
                </div>
                {expandedQuestion === index && (
                faq.Type === "SPECIALIZATION" ? (
                  <ul className={cn("!text-[#1A1A1A]-600", styles.faqAns)} dangerouslySetInnerHTML={{ __html: faq.Answer }} />
                ) : faq.Answer ? (
                  <p className={cn("!text-[#1A1A1A]-600", styles.faqAns, {
                    [styles.jobRoleAns]: isJobRole,
                  })}>
                    {faq.Answer}
                  </p>
                ) : (
                  <div className={cn("!text-[#1A1A1A]-600", styles.faqAns, styles.faqAnsCk)} dangerouslySetInnerHTML={{ __html: faq.AnswerCK }} />
                )
              )}

              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-600">No FAQs available for this category.</p>
        )}
      </div>
    </section>
  );
};

export default FaqWithCategoryProgram;
